import { Box, ButtonProps ,ButtonVariant, Image } from "@mantine/core";
import React from "react";

export const headerButtonProps: ButtonProps & {variant: ButtonVariant} = {
  variant: 'filled',
  color: '#fff',
  c: '#000',
  bd: '1px solid #0000001A',
  radius: 'xl',
  py: 8,
  px: 24,
  fw: 400,
  fz: 12,
}

interface Props {
  children: React.ReactNode
}

export const BaseHeader: React.FC<Props> = ({children}) => {
  return (
    <header>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 16,
          backgroundColor: '#F7E6EB',
        }}
      >
        <Image src="/invy_logo2.png" h={24} w="auto" />
        {children}
      </Box>
    </header>
  )
}
